import React, { useEffect } from 'react';
import PageLayout from "../../../components/PageLayout";
import Account from './Account';
import Support from './support';
import ChangePassword from './changePassword';
import { getAccountSetting } from '../../../store/menu/application/actions';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import TwoFactorAuthentication from './twoFactorAuthentication';


// import TwoFactor from '../../../assets/images/lystfacelogos/AccountSetting/TwoFactor.svg';

const pageName = "Settings"
const moduleName = "Account settings"

const breadcrumbItems = [
    { text: "Home", link: "/" },
    { text: pageName, link: "#" },
    { text: moduleName, link: "#" },
]

const AccountSetting = () => {
    const dispatch = useDispatch();


    const selectAccountSetting = state => state.Application;
    const responseAccountSetting = createSelector(selectAccountSetting, account => ({
        loadingGetAccountDetail: account?.getAccountData?.loading,
        dataAccountDetail: account?.getAccountData?.data,
    }))
    const {
        loadingGetAccountDetail,
        dataAccountDetail
    } = useSelector(responseAccountSetting);


    useEffect(() => {
        dispatch(getAccountSetting())
    }, []);
    return (
        <React.Fragment>
            <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems}>
                <Account loadingGetAccountDetail={loadingGetAccountDetail} />
                {dataAccountDetail && (
                    <>
                        <Support />
                        <TwoFactorAuthentication />
                        <ChangePassword />
                    </>
                )}
            </PageLayout>
        </React.Fragment>
    )
}

export default AccountSetting;